export const getAppLocation = (): Common.Product | 'explorer' | 'extensions' => {
  const locationData = window.location.pathname.split('/');

  const route = locationData?.[1] || null;

  switch (route) {
    case 'editor': {
      return 'editor';
    }
    case 'pdf': {
      return 'pdf';
    }
    case 'presentation': {
      return 'presentation';
    }
    case 'extensions': {
      return 'extensions';
    }
    default: {
      return 'explorer';
    }
  }
};
